// extracted by mini-css-extract-plugin
module.exports = {"header":"GlobalHeader__header--white--1jpF1"};
    if(module.hot) {
      // 1571674778956
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  